<template>
  <div>
    <div class="comm_popup_wrap_medium">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_PIC_TYPE') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PIC_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="picType"
              max-length="100"
              :readonly="true"
              :disabled="true"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onPicPopup"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4> {{ $t('MSG_TXT_PIC_GRPN_COND_IN') }}</h4>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsPicCondtion'"
        :showCountControl="false"
        :showDisplayCountControl="false"
        :multiselect="false"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>

    <sui-popup
      v-model="isShownPopupParam"
      :title="$t('MSG_TIT_PRMT_MGT')"
    >
      <p01
        :pageId="pageId"
        :nodeId="nodeId"
        :selectedRowData="selectedRowData"
        @paramReturn="paramReturn"
        @onClickClose="onClickClose('isShownPopupParam')"
      />
    </sui-popup>
  </div>
</template>
<script>
import p01 from './PGE_CMR_00004_P01';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00002_P02', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    nodeId: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      picType: '',
      localdata0: [],
      isShownPopupParam: false,
      gridColumns0: [{
        text: this.$t('MSG_TXT_PIC_GRPN_STNRD_ITEM'),
        datafield: 'picGroupingItemName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_PRMT'),
        datafield: 'parameter',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextFieldWithButton(row, column, value, htmlElement, {
            textFieldProps: {
              readonly: false,
              disabled: false,
            },
            buttonProps: {
              disabled: false,
              style: 'comm_btn_InputScr',
            },
            handler: this.paramPopupCall,
          }, this.dsPicCondtion, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsPicCondtion',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'picGroupingItemCode', map: 'picGroupingItemCode' },
      { type: 'string', name: 'picGroupingItemName', map: 'picGroupingItemName' },
      { type: 'string', name: 'parameter', map: 'parameter' }],
  }],
  mounted() {
    this.$nextTick(() => {
      this.setGridDefaultList();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 담당자 그룹
     */
    setGridDefaultList() {
      const gridInfo = [
        {
          picGroupingItemName: this.$t('MSG_TXT_SITE'),
          picGroupingItemCode: 'picGroupingSiteId',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_GBM'),
          picGroupingItemCode: 'picGroupingGbmCode',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_LCT'),
          picGroupingItemCode: 'picGroupingAreaMapId',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_TASK_TYPE'),
          picGroupingItemCode: 'picGroupingTaskId',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_DEPT'),
          picGroupingItemCode: 'picGroupingDepartmentId',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_CODE_1'),
          picGroupingItemCode: 'picGroupingCodeValidityValue1',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_CODE_2'),
          picGroupingItemCode: 'picGroupingCodeValidityValue2',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_CODE_3'),
          picGroupingItemCode: 'picGroupingCodeValidityValue3',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_PIC_GRPN_STNRD_END_VAL'),
          picGroupingItemCode: 'picGroupingScopeStartValue',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_PIC_GRPN_STNRD_START_VAL'),
          picGroupingItemCode: 'picGroupingScopeFinishValue',
          parameter: '',
        },
        {
          picGroupingItemName: this.$t('MSG_TXT_PIC_CLSF'),
          picGroupingItemCode: 'picClassificationCode',
          parameter: '',
        },
      ];
      this.dsPicCondtion.setRawData(gridInfo);
    },
    /**
     * Button Event
     */
    onClickCancel() {
      this.$emit('onClickClose');
    },
    onClickApply() {
      const data = [`picTypeId=${this.picType}`];

      if (utils.isEmpty(this.picType)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PIC_TYPE')));
        return false;
      }

      utils.forEach(this.dsPicCondtion.data, obj => {
        if (!utils.isEmpty(obj.parameter)) {
          const picInfo = `${obj.picGroupingItemCode}=${obj.parameter}`;
          data.push(picInfo);
        }
      });
      this.$emit('paramReturn', 'picValue', utils.join(data, '&'));
      this.$emit('onClickClose');

      return null;
    },
    /**
     * 담당자 유형 공통 팝업
     * */
    onPicPopup() {
      utils.openLayerPopup('PGE_CMZ_00006', this.onPicPopupCallback, {
        pageInitialData: {},
        size: 'xlg',
      });
    },
    onPicPopupCallback(nodeData) {
      if (!utils.isEmpty(nodeData)) {
        this.picType = nodeData[0].picTypeId;
      }
    },
    /**
     * 파라미터 팝업
     * */
    paramPopupCall(event, dataRow) {
      this.dataRow = dataRow;
      this.isShownPopupParam = true;
    },
    paramReturn(parameter, data) {
      const rowIndex = utils.findIndex(this.dsPicCondtion.data,
        o => utils.isEqual(o['dataset-row-id'], this.dataRow['dataset-row-id']));
      const oldData = utils.clone(this.dsPicCondtion.data[rowIndex].parameter);

      this.dsPicCondtion.setData(rowIndex, 'parameter', oldData + data);
    },
    onClickClose(data) {
      this[data] = false;
    },
  },
};
</script>
<style scoped>
</style>
